// extracted by mini-css-extract-plugin
export default {"cls1":"UserTaggingPingBodyStyles-cls1_CVh","cls2":"UserTaggingPingBodyStyles-cls2__HC UserTaggingPingBodyStyles-cls1_CVh"};